import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { callPostApi } from "../../../api/ApiCaller";
import * as ApiConst from "../../../api/ApiConst"
import { NO_ERROR } from "../../../api/constants";
import * as clevertapEvents from '../../../clevertapEvents'
import * as staticConstants from '../../../translations/en/en'
import { InformationAlert, LazyLoadedImage, NavHeader, useWindowSize } from "../../common";
import { GlobalContext } from "../../../reducer/context";
import { SHOW_LOGIN_MODAL } from "../../../reducer/actions/userActions";
import { NotFound } from "../../pages";
import * as TRANSLATION from '../../../translations/en/en'
import dateUtilities from "../../../utils/DateUtilities";
import { getFormattedDescription } from "../../dashboard/common/DashboardUtils";
import ClevertapReact from "clevertap-react";

const SpecialOccasion = (props) => {
    const [addBalanceAndPromoCode, setAddBalanceAndPromoCode] = useState({ addBalance: 55, promoCode: "" });
    const { authState: { isAuthenticated }, dispatchAuth } = useContext(GlobalContext)
    const navigate = useNavigate()
    const location = useLocation()
    const size = useWindowSize()

    let itemDetails = {
        "recordId": 7306,
        "active": true,
        "occasionTitle": "Unlock ₹555 for Just ₹55!",
        "sharingContent": "Event Name: STANDUP COMEDY FT. PRITISH NARULA\nVenue: M/s NH 7 PR Realtors, 7W2H+V9, THE OUTLET VILLAGE, Sangrur, Sangrur, Punjab, India, (148001)\nStart Time: 18/04/2025 06:00 PM\nEnd Time: 18/04/2025 08:00 PM",
        "contactNumber": "8557939000",
        "occasionImageUrl": "",
        "restaurantName": "Pyramid Sangrur",
        "paid": true,
        "occasionTicket": [
            {
                "ticketSequenceNumber": 1,
                "occasionRecordId": 1234,
                "ticketName": "Sabse Aage",
                "ticketDescription": "*This ticket grants entry to 1 person only.",
                "ticketPrice": 999,
                "maxNumberOfTickets": 20,
                "termsAndCondition": "1. Tickets once booked cannot be exchanged or refunded\r\n2. An Internet handling fee per ticket may be levied. Please check the total amount before payment\r\n3. We recommend that you arrive at-least 30 minutes prior at the venue for a seamless entry \r\n4. It is mandatory to wear masks at all times and follow social distancing norms\r\n5. Please do not purchase tickets if you feel sick\r\n6. Unlawful resale (or attempted unlawful resale) of a ticket would lead to seizure or cancellation of that ticket without refund or other compensation\r\n7. Rights of admission reserved\r\n8. These terms and conditions are subject to change from time to time at the discretion of the organizer\r\n9. Entry in the auditorium will not be allowed after 30 minutes from show start timing.\r\n10. Getting seats together is not guranteed.\r\n11. Use of mobile phone during the show is strictly prohibited.\r\n12. Seating is on first come first serve basis in all categories (untill n unless seat numbers are mentioned)",
                "giftCouponAmount": 0
            },
            {
                "ticketSequenceNumber": 2,
                "occasionRecordId": 1235,
                "ticketName": "Standard",
                "ticketDescription": "*This ticket grants entry to 1 person only.",
                "ticketPrice": 499,
                "maxNumberOfTickets": 20,
                "termsAndCondition": "1. Tickets once booked cannot be exchanged or refunded\r\n2. An Internet handling fee per ticket may be levied. Please check the total amount before payment\r\n3. We recommend that you arrive at-least 30 minutes prior at the venue for a seamless entry \r\n4. It is mandatory to wear masks at all times and follow social distancing norms\r\n5. Please do not purchase tickets if you feel sick\r\n6. Unlawful resale (or attempted unlawful resale) of a ticket would lead to seizure or cancellation of that ticket without refund or other compensation\r\n7. Rights of admission reserved\r\n8. These terms and conditions are subject to change from time to time at the discretion of the organizer\r\n9. Entry in the auditorium will not be allowed after 30 minutes from show start timing.\r\n10. Getting seats together is not guranteed.\r\n11. Use of mobile phone during the show is strictly prohibited.\r\n12. Seating is on first come first serve basis in all categories (untill n unless seat numbers are mentioned)",
                "giftCouponAmount": 0
            }
        ],
        "occasionAddress": "M/s NH 7 PR Realtors, 7W2H+V9, THE OUTLET VILLAGE, Sangrur, Sangrur, Punjab, India, (148001)",
        "startDateTimeStamp": 1744979400000,
        "endDateTimeStamp": 1744986600000,
        "latitude": 30.2523,
        "longitude": 75.9288
    }

    useEffect(() => {
        if (!isAuthenticated) {
            if (size[0] > 1080) {
                navigate("/")
            } else {
                dispatchAuth({ type: SHOW_LOGIN_MODAL });
                // navigate("/login")
            }
        }

    }, [navigate])


    const customStyles = {
        width: "60%",
        display: "flex",
        marginLeft: "20%",
        marginTop: "77px",
        marginBottom: "77px"
    }
    const addAmountBy = (addValue) => {
        setAddBalanceAndPromoCode(prev => ({ ...prev, addBalance: addValue }))
    }
    const handleAddBalanceAndPromoChange = (e) => {
        const { name, value } = e.target
        if (name === "addBalance") {
            setAddBalanceAndPromoCode(prev => ({ ...prev, [name]: parseInt(value) }))
        } else {
            setAddBalanceAndPromoCode(prev => ({ ...prev, [name]: value }))
        }
    }

    const handleApplyCoupon = () => {
        if (!addBalanceAndPromoCode.promoCode) {
            toast(staticConstants.PLEASE_ENTER_PROMO_CODE)
            return
        }
        const rUrl = ApiConst.Post_Redeem_Voucher
        // order reference id 
        const rObj = { voucherCode: addBalanceAndPromoCode.promoCode }
        const toastId = toast.loading(staticConstants.VERIFYING_COUPON)
        callPostApi(rUrl, rObj, {}, response => {
            if (response.errorCode === NO_ERROR) {
                clevertapEvents.voucherConsumeEvent(addBalanceAndPromoCode.promoCode)
                toast.dismiss(toastId)
                InformationAlert({ message: response.message })
                setAddBalanceAndPromoCode({ ...addBalanceAndPromoCode, promoCode: "" })
                if (props?.getRewardPointAndWalletBalance) {
                    props.getRewardPointAndWalletBalance()
                }
            } else {
                toast.dismiss(toastId)
                InformationAlert({ message: response.message })
            }
        })
    }

    const handleAddWalletBalanceSecurely = () => {
        const addCashObj = {
            payAtEventRemark: "Offer55"
        }
        callPostApi(ApiConst.Post_checkTxnExist, addCashObj, {}, (res) => {
            if (res.errorCode === NO_ERROR) {
                if (res.responsePacket) {
                    InformationAlert({ title: "Pyramid Vip", message: "You have already purchased this offer." });
                    return;
                }
                else {

                    if (!addBalanceAndPromoCode.addBalance) {
                        toast(staticConstants.PLEASE_SELECT_AMOUNT_TO_BE_ADDED)
                        return
                    }
                    const action = "Add_Wallet_Balance"
                    navigate("/payment-methods", { state: { payableUsingGateWay: addBalanceAndPromoCode.addBalance, payableUsingWallet: 0, previousPath: location.pathname, action, specialOccasion: true } })
                }

            }
        });

    }

    return (
        !isAuthenticated ? <NotFound title={staticConstants.UN_AUTHORIZED_ACCESS} /> :
            <>
                {/* <div style={props?.getRewardPointAndWalletBalance ? null : customStyles} className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="tabs-holder horizontal h-90">
                            <div className="tab-content bg-white h-100 ">
                                <div id="home" className="tab-pane fade in active show">
                                    <div className="menu-itam-holder">
                                        <div className="d-flex align-items-center justify-content-start gap-2 mb-4">
                                            <div>
                                                <img
                                                    src="../img/wallet.png"
                                                    alt="wallet"
                                                    width="25px"
                                                />
                                            </div>
                                            <div className="item-title">
                                                <h5 className="text-color mb-0 font-weight-800 font-size-16">
                                                    {staticConstants.ADD_TO_YOUR_WALLET}
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="bg-gray-1 border-radius-5 p-2 border-dark mb-4">
                                            <input
                                                type="number"
                                                style={{ background: "transparent" }}
                                                placeholder="Enter Amount"
                                                className="mb-0 font-size-14 font-weight-600 text-gray w-100"
                                                value={addBalanceAndPromoCode.addBalance || ""}
                                                onChange={handleAddBalanceAndPromoChange}
                                                name="addBalance"
                                            />
                                        </div>
                                        <div className="row mx-auto pb-4 border-bottom">
                                            {(props?.getRewardPointAndWalletBalance ? [2000, 5000, 10000] : [55]).map(
                                                (currentAmount, i) => (
                                                    <div
                                                        key={i}
                                                        onClick={() => addAmountBy(currentAmount)}
                                                        style={{ cursor: "pointer" }}
                                                        className="col-4 width-100"
                                                    >
                                                        <div className="wallet-box border-radius-5 d-flex justify-content-center align-items-center">
                                                            <h5 className="font-weight-800 font-size-16 text-center text-gray mb-0">
                                                                +₹{currentAmount}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                            <div className=" col-md-12 d-flex justify-content-center align-items-center mt-4">
                                                <span
                                                    onClick={handleAddWalletBalanceSecurely}
                                                    className="custom-btn btn bg-yellow text-black w-100"
                                                >
                                                    {staticConstants.ADD_SECURELY}
                                                </span>
                                            </div>
                                        </div>
                                        {props?.getRewardPointAndWalletBalance ? <>
                                            <div className="d-flex align-items-center justify-content-start gap-2 my-4">
                                                <div>
                                                    <img
                                                        src="../img/wallet.png"
                                                        alt="wallet"
                                                        width="25px"
                                                    />
                                                </div>
                                                <div className="item-title">
                                                    <h5 className="text-color mb-0 font-weight-800 font-size-16">
                                                        {staticConstants.HAVE_A_PROMO_CODE}
                                                    </h5>
                                                </div>
                                            </div>
                                            <div className="bg-gray-1 border-radius-5 p-2 border-dark mb-4 ">
                                                <input
                                                    type="text"
                                                    style={{ background: "transparent" }}
                                                    placeholder="Enter Code"
                                                    className="mb-0 font-size-14 font-weight-600 text-gray w-100"
                                                    value={addBalanceAndPromoCode.promoCode}
                                                    onChange={handleAddBalanceAndPromoChange}
                                                    name="promoCode"
                                                />
                                            </div>
                                            <div className="  d-flex justify-content-center align-items-center mb-4">
                                                <span
                                                    onClick={handleApplyCoupon}
                                                    className="custom-btn btn bg-yellow text-black w-100"
                                                >
                                                    {staticConstants.APPLY_CODE}
                                                </span>
                                            </div>
                                        </> : null}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className="special-ocassion my-2">
                    <div className=' col-xl-3 col-lg-4 col-md-6 col-sm-8 col-xs-12 h-100' style={{ flex: "1 0 auto" }}>
                        <div className="Events_Details h-100 position-relative">
                            <div className=' Events_Details-box bg-white shadow-sm'>
                                <div className=" position-absolute px-3 pt-3" style={{ top: "0px", left: "0px", right: "0px", paddingBottom: "60px" }}>
                                    <div className='img-box border'>
                                        {/* <img src={itemDetails.occasionImageUrl} alt='occasionImageUrl' /> */}
                                        <img
                                            src={"./img/Chamatkari-Offer.jpg"}
                                            alt="Event"
                                            wrapperClassName="image-holder w-100"
                                            style={{ height: "50%" }}

                                        />
                                    </div>
                                    <div className='border p-1 rounded mt-2'>
                                        <div className="col-12">
                                            <div style={{ color: "#f6b547" }} className="d-flex align-items-center justify-content-center font-size-18"><text className="  font-weight-700 mt-2">{itemDetails.occasionTitle}</text></div>
                                            <text style={{ fontSize: "13px" }}>Feast Like Royalty at Pyramid – Where Every Sip is a Treasure!</text>
                                        </div>
                                        <div>
                                            {/* <p className='mb-0 font-size-12'>{itemDetails.description}</p> */}
                                            <div className='mb-0 font-size-12 mt-2 '>
                                                <ul>
                                                    <li style={{ marginBottom: "15px" }}>
                                                        ✨ How It Works:
                                                        <ul style={{ marginTop: "5px" }}>
                                                            <li>Step 1 Buy: Purchase the ₹55 coupon and unlock ₹555 in Offers/Rewards section in Pyramid VIP Web/Mobile APP.</li>
                                                            <li>Step 2 Dine In: Visit any Pyramid outlet within 30 days and Apply this E-Coupon at the time of Placing the order</li>
                                                        </ul>
                                                    </li>
                                                    <li className="p-2" style={{ marginBottom: "15px", border: "1px solid #eee" }}>
                                                        📜 Terms & Conditions:
                                                        <ul style={{ marginTop: "5px", listStyleType: "disc", paddingLeft: "20px" }}>
                                                            <li>Valid for dine-in only at all Pyramid outlets.</li>
                                                            <li>Coupon must be redeemed within 30 days of purchase.</li>
                                                            <li>Minimum order value of ₹999 required to apply ₹555 credit.</li>
                                                            <li>Cannot be clubbed with other offers or discounts.</li>
                                                            <li>Right to admission reserved in the last T&c</li>
                                                        </ul>

                                                    </li>
                                                </ul>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className=' view-card-btn bg-black text-center p-0 cursor-pointer' style={{ bottom: "0px", left: "0px", right: "0px", position: "absolute" }}>
                                <span onClick={handleAddWalletBalanceSecurely} className='text-yellow py-3 font-size-16 font-weight-900 text-yellow d-block text-center event-reserve-btn '>{"Buy Offer ₹55"}</span>
                            </div>
                        </div>
                    </div>
                </div>


            </>
    );
};

export default SpecialOccasion;
